import styled from "styled-components"
import { ReactComponent as Loader } from '../loader.svg';
import useStore from '../store/index'

import React, { useEffect, useState } from 'react'

export function Loading({ initaite }) {
    
    const [loading, setLoading] = useState(initaite === true);
    const setLoadingState = useStore((state) => state.setLoading);
    const loadingState = useStore((state) => state.loading);


    // if (loading){
    //     setLoadingState(true);
    //     setTimeout(() => {
    //         setLoadingState(false);
            
    //         setLoading(loadingState);
    //     }, 3000)
    // }
    
    return (
        <>
            {loading && <PreLoaderView className="bg-gray-100">
                <div className="loader">
                    <Loader className="ldimg" />
                    <h4 className="font-semibold text-md">Please Wait ...</h4>
                </div>
            </PreLoaderView>}
        </>
    )
}

export function LoadingData({ message }) {
  return (
    <div className="bg-transparent flex py-4 items-center justify-center w-full flex-col">
        <div className="text-center">
            <Loader className=" h-8 w-8" />
            <h4 className="font-semibold text-xs">{message}</h4>
        </div>
    </div>
  )
}


const PreLoaderView = styled.div`
    position: fixed;
    top: -6px;
    right: 0;
    width: 100vw;
    height: 100vh;
    z-index: 99999;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    overflow-y: hidden;
    
    .loader{
        test-align: center;
        .ldimg{
            height: 68px;
            width: 68px;
        }
    }
`;